import _ from "lodash";
import React from "react";

import HOWTHE from "./HowTheWorldWorks";
import HOWTHEactive from "./HowTheWorldWorksActive";
import HOWWEE from "./HowWeExpressOurselves";
import HOWWEEactive from "./HowWeExpressOurselvesActive";
import HOWWEO from "./HowWeOrganizeOurselves";
import HOWWEOactive from "./HowWeOrganizeOurselvesActive";
import SHARIN from "./SharingThePlanet";
import SHARINactive from "./SharingThePlanetActive";
import WHEREW from "./WhereWeAreInPlaceAndTime";
import WHEREWactive from "./WhereWeAreInPlaceAndTimeActive";
import WHOWEA from "./WhoWeAre";
import WHOWEAactive from "./WhoWeAreActive";

export const themeIcon = ({ metadata, isSelected, themeLabel }) => {
  let themeSvg;
  const icon = _.get(metadata, "icon", null);

  switch (icon) {
    case "HOWTHE":
      if (isSelected) {
        themeSvg = <HOWTHEactive label={themeLabel} />;
      } else {
        themeSvg = <HOWTHE label={themeLabel} />;
      }
      break;
    case "HOWWEO":
      if (isSelected) {
        themeSvg = <HOWWEOactive label={themeLabel} />;
      } else {
        themeSvg = <HOWWEO label={themeLabel} />;
      }
      break;
    case "HOWWEE":
      if (isSelected) {
        themeSvg = <HOWWEEactive label={themeLabel} />;
      } else {
        themeSvg = <HOWWEE label={themeLabel} />;
      }
      break;
    case "SHARIN":
      if (isSelected) {
        themeSvg = <SHARINactive label={themeLabel} />;
      } else {
        themeSvg = <SHARIN label={themeLabel} />;
      }
      break;
    case "WHEREW":
      if (isSelected) {
        themeSvg = <WHEREWactive label={themeLabel} />;
      } else {
        themeSvg = <WHEREW label={themeLabel} />;
      }
      break;
    case "WHOWEA":
      if (isSelected) {
        themeSvg = <WHOWEAactive label={themeLabel} />;
      } else {
        themeSvg = <WHOWEA label={themeLabel} />;
      }
      break;
    default:
      themeSvg = <WHOWEA />;
      break;
  }

  return themeSvg;
};
